module.exports = __webpack_public_path__ + "static/media/minneapolis.087bbae7.jpg";